
import { notify } from "@kyvg/vue3-notification";
import router from "./router";


export function handleRequestErrors(status) {

    const redirectToLogin = () => {
        router.push('/login');
    };

    const redirectToTwoAuthenticationFactor = () => {
        router.push('/two-authentication-factor');
    };

    const redirectToAcceptTermUse = () => {
        router.push('/accept-term-use');
    };

    if (status == 401) {
        notify({
            title: "Falha",
            text: "Sessão encerrada!",
            type: 'error'
        });
        redirectToLogin();
    } else if (status == 403) {
        notify({
            title: "Falha",
            text: "Você não tem permissão para acessar o recurso solicitado!",
            type: 'error'
        });

        router.push('/');

    } else if (status == 422) {
        notify({
            title: "Falha",
            text: "Há validações pendentes!",
            type: 'error'
        });
    } else if (status == 423) {
        notify({
            title: "Falha",
            text: "Requisição não aceita pelo sistema (423)!",
            type: 'error'
        });
    } else if (status == 428) {
        notify({
            title: "Falha",
            text: "É necessário confirmar o código de duplo fator de autenticação enviada para seu e-mail!",
            type: 'error'
        });
        redirectToTwoAuthenticationFactor();
    } else if (status == 429) {
        notify({
            title: "Falha",
            text: "Foram realizadas várias tentativas de finalização de sessão! Aguarde alguns instantes e tente novamente!",
            type: 'error'
        });
        redirectToLogin();
    }else if (status == 451) {
        notify({
            title: "Falha",
            text: "É necessário ler e aceitar os termos de uso para prosseguir!",
            type: 'error'
        });
        redirectToAcceptTermUse();
    } else if (status == 500) {
        notify({
            title: "Falha",
            text: "Não foi possível encerrar a sessão! Por gentileza, contacte o suporte técnico para mais detalhes",
            type: 'error'
        });

    } else if (status == 503) {
        notify({
            title: "Falha",
            text: "Não foi obter o recurso desejado (503)! Por gentileza, contacte o suporte técnico para mais detalhes",
            type: 'error'
        });

    }
}